import React from 'react';

interface ModalProps {
    message: string | null;
    onClose: () => void;
    showCopyButton?: boolean;
    textToCopy?: string;
}

export const Modal: React.FC<ModalProps> = ({
    message,
    onClose,
    showCopyButton = false,
    textToCopy = ''
}) => {
    if (!message) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            alert('URLをコピーしました！');
        } catch (error) {
            console.error('コピーに失敗しました:', error);
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <p className="text-lg font-semibold mb-4 break-words whitespace-pre-line">
                    {message}
                </p>
                <div className="flex flex-col sm:flex-row gap-2 justify-center">
                    {showCopyButton && textToCopy && (
                        <button
                            onClick={handleCopy}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg transition"
                        >
                            URLをコピー
                        </button>
                    )}
                    <button
                        onClick={onClose}
                        className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-lg transition"
                    >
                        閉じる
                    </button>
                </div>
            </div>
        </div>
    );
}; 